<template>
    <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_5825_2343)">
            <path d="M14.8675 11.4883H11.3867V14.8615H14.8675V11.4883Z" fill="#FF7E00"/>
            <path d="M0.651772 0.651772H17.3517V17.3482H0.651772V0.651772ZM0 18H18V0H0V18Z" fill="#52B300"/>
            <path d="M16.7011 3.97223V1.30273H1.30469V16.6991H6.26578V11.693L3.91524 13.0242V11.3775L16.7011 3.97223ZM9.09822 4.48879H11.525V6.22223L9.09822 7.62284V4.48879Z" fill="#52B300"/>
        </g>
        <defs>
            <clipPath id="clip0_5825_2343">
                <rect width="18" height="18" fill="white"/>
            </clipPath>
        </defs>
    </svg>
</template>

<script>
export default {
    name: 'IconLogo'
}
</script>